module.exports = __webpack_public_path__ + "static/media/Muli-ExtraLight.9ed40730.woff2";